const updateUrlWithHeightAndWidth = (url, imgSize) => {
  if (!url) return '';
  const { w = 50, h = 50, fit = 'facearea' } = imgSize || {};
  return `${url}?w=${w}&h=${h}&fit=${fit}&facepad=3`;
};

export default updateUrlWithHeightAndWidth;
